export const SKIN_SCREENING_DEV = 'https://beauty-ms-scan-skin.vercel.app/';
export const SKIN_SCREENING_STAG = 'https://beauty-ms-scan-skin.vercel.app/';
export const SKIN_SCREENING_PRODUCT = 'https://beauty-ms-scan-skin.vercel.app/';
